import { AfterContentInit, Component, ContentChildren, Directive, ElementRef, Input, QueryList } from '@angular/core';
import { getParentScroll } from '@myia/ngx-core';

@Directive({
  selector: '[transition-group-item]'
})
export class TransitionGroupItemDirective {
  prevPos: any;

  newPos: any;

  el: HTMLElement;

  moved = false;

  moveCallback: any;

  // @Input() transitionDisabled: boolean;


  constructor(elRef: ElementRef) {
    this.el = elRef.nativeElement;
  }
}

@Component({
  selector: '[transition-group]',
  template: '<ng-content></ng-content>'
})
export class TransitionGroupComponent implements AfterContentInit {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('transition-group') class: string | undefined;

  @ContentChildren(TransitionGroupItemDirective) items: QueryList<TransitionGroupItemDirective> | undefined;

  _parentScroll?: HTMLElement;

  constructor(private _elRef: ElementRef) {
  }

  ngAfterContentInit() {
    this._parentScroll = getParentScroll(this._elRef.nativeElement);
    setTimeout(() => this.refreshPosition('prevPos'), 0); // save init positions on next 'tick'

    if (!this.items) {
      throw new Error('No child TransitionGroupItemDirectives found!');
    }
    this.items.changes.subscribe(items => {
      items.forEach((item: TransitionGroupItemDirective) => item.prevPos = item.newPos || item.prevPos);
      items.forEach(this.runCallback);
      this.refreshPosition('newPos');
      items.forEach((item: TransitionGroupItemDirective) => item.prevPos = item.prevPos || item.newPos); // for new items

      const animate = () => {
        items.forEach(this.applyTranslation);
        // eslint-disable-next-line @typescript-eslint/dot-notation
        (this as any)['_forceReflow'] = document.body.offsetHeight; // force reflow to put everything in position
        this.items?.forEach(this.runTransition.bind(this));
      };

      const willMoveSome = items.some((item: TransitionGroupItemDirective) => {
        const dx = item.prevPos.left - item.newPos.left;
        const dy = item.prevPos.top - item.newPos.top;
        return dx || dy;
      });

      if (willMoveSome) {
        animate();
      } else {
        setTimeout(() => { // for removed items
          this.refreshPosition('newPos');
          animate();
        }, 0);
      }
    });
  }

  itemsUpdated() {
    this.refreshPosition('prevPos');
  }

  private runCallback(item: TransitionGroupItemDirective) {
    if (item.moveCallback) {
      item.moveCallback();
    }
  }

  private runTransition(item: TransitionGroupItemDirective) {
    if (!item.moved) {
      return;
    }
    const cssClass = this.class + '-move';
    const el = item.el;
    const style: any = el.style;
    el.classList.add(cssClass);
    style.transform = style.WebkitTransform = style.transitionDuration = '';
    el.addEventListener('transitionend', item.moveCallback = (e: any) => {
      if (!e || /transform$/.test(e.propertyName)) {
        el.removeEventListener('transitionend', item.moveCallback);
        item.moveCallback = null;
        el.classList.remove(cssClass);
      }
    });
  }

  private refreshPosition(prop: string) {
    if (!this.items) {
      throw new Error('No child TransitionGroupItemDirectives found!');
    }
    this.items.forEach(item => {
      const rect = item.el.getBoundingClientRect();
      const itemObj: any = item;
      itemObj[prop] = {
        left: rect.left,
        top: rect.top
      };
      if (this._parentScroll) {
        const scrollX = this._parentScroll.scrollLeft;
        const scrollY = this._parentScroll.scrollTop;
        itemObj[prop].left += scrollX;
        itemObj[prop].top += scrollY;
      }
    });
  }

  private applyTranslation(item: TransitionGroupItemDirective) {
    item.moved = false;
    const dx = item.prevPos.left - item.newPos.left;
    const dy = item.prevPos.top - item.newPos.top;
    if (dx || dy) {
      item.moved = true;
      const style: any = item.el.style;
      style.transform = style.WebkitTransform = 'translate(' + dx + 'px,' + dy + 'px)';
      style.transitionDuration = '0s';
    }
  }
}
